import React from 'react';
import { Code2 } from 'lucide-react';

const Footer = ({ t }) => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <Code2 size={32} />
            <span className="footer-name">Lucas Gonzales de Souza</span>
          </div>
          
          <div className="footer-tagline">
            {t.footer.tagline}
          </div>
          
          <div className="footer-rights">
            {t.footer.rights}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;